
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';

function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);

    const [titleCategorie, setIitleCategorie] = useState('');

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);

    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);
    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: 'white', marginBottom: 30, textDecoration: 'none', 
                width: 300,
                 height: 400,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                  borderRadius: 30,
            }}>
                <img src={image}  style={{width: 300, height: 250, objectFit: 'cover',    borderRadius: 30,}}/>
                <h3 style={
                    { fontFamily: "LondrinaSolidRegular", color: 'black', textTransform: 'uppercase', fontSize: 22, fontWeight: '500',margin: 0, textAlign: 'center' }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '80%', margin: '0 auto'}}>
                    <p
                        className='shor-text'
                        style={{ fontFamily: "LondrinaSolidLight",fontSize: 15, color: '#6D6D6D', textAlign: 'center', margin: 0,}}>

                        { data.regular_decription
                        }
                        
                        
                    </p>
                </div>

                <div style={{
                      width: '100%',
                        alignSelf: 'center',
                        backgroundColor: '#D7BF89',
                        borderColor: '#0073C1',
                        padding: '10px 0px',
                        marginTop: 20,
                        borderRadius: 9,
                        position: 'absolute',
                        bottom: 0,
                }}>
                <div
                    style={data.price2
                            ? {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            padding: '0 20px'
                        }
                        : {}}>
                    <p
                    style={
                        {
                        color: '#000',
                        fontSize: 18,
                        fontWeight: 'bold',
                        textAlign: 'center',
                        }
                    }>
                            
                            {data.flavors == 0 ? '': 'SEE OPTIONS'}
                       
                            {data.flavors == 0 && 
                            <>
                            {data.price > 0 
                                ? `${data.label_price ?? ''} $${data.price.toFixed(2)}`
                            : 'Market Price'}
                            </>}
                            
                       
                    </p>

            {data.price2 && (
              <p
                style={
                  {
                    color: '#000',
                    fontSize: 18,
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }
                }>
                {data.price > 0
                  ? `${data.label_price2 ?? ''} $${data.price2.toFixed(2)}`
                  : 'Market Price'}
              </p>
            )}
          </div>
                </div>
                

                
                
            </div>
        );
    }

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} goHome={goHome} setShowListProduct={setShowListProduct}  setShowSpecials={setShowSpecials}>
                <div >
                     <img
                        src={require('./assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: 140,
                        marginTop: -10,
                        }}
                    />

                    <div style={{
                        zIndex: -1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 40px',
                          marginTop: -60,
                    
                    }}>
                        <p style={{ fontFamily: "Arial", fontSize: 40, color: 'white', margin: 0 }}>{titleCategorie}</p>
                        
                        
                    </div>
                   
                        {dishs.id === 632 && <div>
                            <p style={{ fontFamily: "Arial", fontSize: 12, color: 'white', margin: 0 }}>
                            {langEng ? 'Available from 12-4pm' : 'Disponible de 12-4pm'}
                            </p></div>}


                    <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            padding: '0px 40px 100px 40px',
                            height: 550,
                            overflow: 'scroll',
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                    </div>   
                    
      

                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowListProduct} />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;